module.exports = __webpack_public_path__ + "public/images/reading.065aea2cc40cb81c7d98c7722c7d186b.png";